import { render, staticRenderFns } from "./SatisfaccionPorClientesKPI.vue?vue&type=template&id=2fb3f166&scoped=true&"
import script from "./SatisfaccionPorClientesKPI.vue?vue&type=script&lang=js&"
export * from "./SatisfaccionPorClientesKPI.vue?vue&type=script&lang=js&"
import style0 from "./SatisfaccionPorClientesKPI.vue?vue&type=style&index=0&id=2fb3f166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb3f166",
  null
  
)

export default component.exports